module.exports = __webpack_public_path__ + "static/media/online-magazine-card.ddfdf0db.svg";